export default __webpack_public_path__ + "static/media/eye-white.cd898a99.svg";